"use strict";

module.exports = {
  AUTH: '/auth',
  AUTH2: '/auth2',
  WELCOME: '/welcome',
  WELCOME_ADMIN: '/welcome-admin',
  DASHBOARD: '/my-videos',
  CREATE_COLLECTION: '/template2',
  PRODUCT: '/product',
  TEMPLATE: '/template',
  CREATE: '/create',
  EDIT: '/edit',
  PUBLISH: '/publish',
  PRIVACY_POLICY: '/privacy-policy',
  FAQ: '/faq',
  EMBEDDED_VIDEO: '/embedded',
  ADMIN: '/admin',
  IMAGE: '/image',
  BLOG: '/blog',
  PRICING: '/pricing',
  BILLING: '/billing'
};